var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.$i18n.locale = _vm.locale_computed}}},[_vm._v(_vm._s(_vm.locale_computed2))])
}
var staticRenderFns = []

export { render, staticRenderFns }